import React from 'react'
import { Row, Col, Icon } from 'antd'
import './styles.scss'
import FileItem from './file-item'


export default ({ selectedAccount, downloadInvoiceData, on_download}) => {
    console.log(downloadInvoiceData)
    return (
    <div>
        <Row type="flex" gutter={30} className="download-container">
            <Col span={15}>
                <div className="billing-container">
                    <div className="files">
                        {downloadInvoiceData.map((file, i) => {return <FileItem key={i} file={file} on_download={on_download} />})}
                    </div>
                </div>
            </Col>
            <Col span={9}>
                <Row>
                    <Col span={24}>
                        <div className="billing-help-container">
                            <span >
                                <Icon className="detailed-billing" type="file-text"/>
                                <a href="https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/DetailedBillingReport.html" target="_blank">
                                    Detailed Billing Report
                                </a>
                            </span>
                            <span >
                                <Icon type="file-text"/>
                                <a href="https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/reportstagsresources.html" target="_blank">
                                    Detailed Billing Report with Resources and Tags
                                </a>
                            </span>
                            <span >
                                <Icon type="file-text"/>
                                <a href="https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/monthly-report.html" target="_blank">
                                    Monthly Report
                                </a>
                            </span>
                            <span >
                                <Icon type="file-text"/>
                                <a href="https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/reportwithtags.html" target="_blank">
                                    Monthly Cost Allocation Report
                                </a>
                            </span>

                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>
)}